import React from "react";
import { SectionHeader } from "./SectionHeader";

export const Services = ({ data, section }) => {
  const s = section || {};
  return (
    <div id="services" className="text-center">
      <div className="container">
        <SectionHeader heading={s.heading} subheading={s.subheading} />
        <div className="row">
          {data
            ? data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4 service-pillar">
                  <i className={d.icon}></i>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                    {d.bullets && (
                      <ul className="service-bullets">
                        {d.bullets.map((b, j) => (
                          <li key={j}>
                            {/* b is now { icon, text } — icon matches the bullet topic */}
                            <span className="bullet-icon">
                              <i className={b.icon}></i>
                            </span>
                            <span className="bullet-text">{b.text}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ))
            : null}
        </div>
        {s.cta_label && (
          <div className="row text-center" style={{ marginTop: "30px" }}>
            <a
              href={s.cta_href || "#contact"}
              className="btn btn-custom btn-lg page-scroll"
            >
              {s.cta_label}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
